import React from 'react';
import { createEventEmitter } from './EventEmitter';
import QueuedNotifier from './QueuedNotifier';
import { createNotifier } from './createNotifier';

const emitter = createEventEmitter();
const Notifier = createNotifier(emitter);

export const createQueuedNotifier = () => {
  const InitializedQueuedNotifier = props => (
    <QueuedNotifier {...props} emitter={emitter} />
  );

  return {
    QueuedNotifier: InitializedQueuedNotifier,
  };
};

export default Notifier;
